import { RpeFieldRegistry } from 'src/app/shared/rpe/rpe.model';
import { MAWB_RPE_ATTACHMENTS_TAB_ID, MAWB_RPE_AP_TAB_ID, MAWB_RPE_AR_TAB_ID, MAWB_RPE_INVALID_TAB_AND_LEGEND_ID, MAWB_RPE_MISCELLANEOUS_TAB_ID, MAWB_RPE_NOTES_TAB_ID, MAWB_RPE_STATUSCODES_TAB_ID } from './mawb-rpe.constants';

export const MAWB_RPE_FIELD_REGISTRY: RpeFieldRegistry = [
  {
    binding: {
      tabId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'clearanceTypeCode',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'agentName',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'information',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_STATUSCODES_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'additionalDetails',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_NOTES_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'ibc',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_NOTES_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'customer',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_ATTACHMENTS_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'description',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_MISCELLANEOUS_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'usCbpEccf86EntryNumber',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_MISCELLANEOUS_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'clearanceAgent',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_MISCELLANEOUS_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'linehaulCharge',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_AR_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'chargeCode',
    },
  },
  {
    binding: {
      tabId: MAWB_RPE_AR_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'chargeAmount',
    },
  },
  {
    // Match DB grant by identityName only — do not hard-require AP tabId.
    matchByIdentityNameOnly: true,
    binding: {
      tabId: MAWB_RPE_AP_TAB_ID,
      legendId: MAWB_RPE_INVALID_TAB_AND_LEGEND_ID,
      identityName: 'agentChargeCode',
    },
  },
];